const article = {
	slug: "nist-tevv-gap",
	title: "The AI Governance Role Your Framework Assumes You Already Have",
	date: "16 April 2026",
	updated: null,
	description:
		"NIST names an independent AI reviewer role, the TEVV specialist, that most organizations have never heard of. Adopting the framework is easy. Building the human infrastructure it assumes is the hard part.",
	keywords: [
		"NIST AI RMF",
		"AI governance",
		"TEVV",
		"AI risk management",
		"model validation",
		"FinServ AI",
	],
	tldr: "NIST already named the independent reviewer who should check AI output before it ships. Most companies have never heard the term, and the framework never tells you how to build the role.",
	readingTime: null,
	provenance: "Adapted from my LinkedIn post first shared with AI governance and risk leaders in April 2026.",
	provenanceUrl: null,
	series: "ai-governance-for-finserv-leaders",
	artifact: "tevv-template",
	markdown: `Right now, a developer is shipping production code written entirely by an AI. No review. No second set of eyes. The process does not require it.

This is not a prediction. This is happening today at companies of every size, in every industry.

The NIST AI Risk Management Framework has been available since 2023. Three years later, most organizations still cannot answer the most basic question it raises. And when something breaks, the conversation that follows is always the same.

**Who owned this?**

The developer points to the AI. The manager points to the process. The executive points to the team. Nobody has a clean answer, because nobody defined one before the code went live.

## NIST already named the person who should have been in the room

The framework calls them a TEVV specialist. Test, Evaluation, Verification, and Validation. An independent reviewer whose only job is to check that the AI output is doing what the team thinks it is doing.

Most companies do not have this role. Most companies have never heard the term.

The framework does not tell you how to hire this person. It does not tell you where they sit on the org chart. It does not define a minimum viable team for organizations that cannot afford a dedicated reviewer.

It just assumes the capability exists.

## Adopting a framework is the easy part

Building the human infrastructure it assumes you already have is the hard part. That is the conversation most organizations are not having yet.

I have been thinking about this problem across every AI initiative I have been part of. The answer is rarely a new hire. It is almost always a defined process and a named owner. Two things most teams can do this quarter.`,
};

export default article;
